import React from "react";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";

import ReactTooltip from "react-tooltip";
import "lightgallery.js/dist/css/lightgallery.css";

import './LightGalleryStyle.scss';



const LightGallery = (props) => {
    const PhotoItem = ({ image, title, group }) => (
        <div className="gallery__image__box">
            <LightgalleryItem group={group} src={image}>
                <div
                    role="button"
                    tabIndex={0}
                    aria-label={`View full size: ${title || "gallery photo"}`}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.currentTarget.click()
                        }
                    }}
                >
                    <img src={image} className="gallery__image" alt={title || "Authentic Vietnamese dish from Sit Lo Saigon gallery"} />
                </div>
            </LightgalleryItem>
        </div>
    );
    return (
        <div className="gallery__grid-container" data-tip="Click to view photo">
            <LightgalleryProvider>
                {props.items.map((item, index) => (
                    <div className="box" key={index}>
                        <PhotoItem image={item.url} title={item.title} />
                    </div>
                ))}
            </LightgalleryProvider>
            <ReactTooltip place="top" type="dark" effect="float" />
        </div>
    )
}


export default LightGallery
